import React from 'react';
import { TwoColumns } from './TwoColumns';
import { Accordion, AccordionItem } from './Accordion';
import Module from './Module';
import { PLACEHOLDER_TYPE_CORE_ELECTIVE } from '../Util/Module';
import Link from '../Util/Paths';
import { withRouter } from 'react-router-dom';
import Tooltip from './Tooltip';
import { localize } from '../Util/L10n';
import qs from 'qs';

class Overview extends React.Component {
  state = { clipboard: 'Copy to clipboard' };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  semesters = () => {
    return this.props.semesters.map((semester, key) => {
      return (
        <Accordion key={semester.uid} open={key === 0 ? 0 : null}>
          <AccordionItem title={semester.name}>
            <div className="space-y-sm">
              {this.modules(semester, key)}
              <Link
                to="semester"
                params={{
                  studyplan: this.props.match.params.studyplan,
                  semester: key + 1,
                }}
                className="semester-link mt-4 d-flex align-items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.824"
                  height="20"
                  className="icon rotate mr-3"
                  viewBox="0 0 28.824 20"
                >
                  <path d="M1.007,11.1,9.15,20l1.007-1.1L2.745,10.8H28.824V9.2H2.745l7.412-8.1L9.15,0,0,10Z" />
                </svg>
                {localize('overviewGoToSemester', key + 1)}
              </Link>
            </div>
          </AccordionItem>
        </Accordion>
      );
    });
  };
  modules = (semester, key) => {
    return semester.modules.map((module) => {
      let showModule = module;
      if (module.placeholderType === PLACEHOLDER_TYPE_CORE_ELECTIVE) {
        const selected =
          this.props.selectedModules[key + 1][`selected-${module.uid}`];
        showModule = module.coreElectiveModules.find(
          (module) => module.uid === selected
        );
      }
      return <Module module={showModule} key={showModule.uid} />;
    });
  };
  getEncodedCourse = () => {
    return btoa(JSON.stringify(this.props.selectedModules));
  };

  deepLink = (absolute = false) => {
    const { studyplan } = this.props.match.params;
    let url = `/studyplan/${studyplan}/overview?module=${this.getEncodedCourse()}`;
    if (absolute) {
      url = new URL(`#${url}`, location).href;
    }
    return url;
  };

  onCopy = async (e) => {
    e.preventDefault();
    try {
      const text = this.deepLink(true);
      await window.navigator.clipboard.writeText(text);
      this.setState({ clipboard: localize('linkCopied') });
    } catch (e) {
      this.setState({ clipboard: localize('couldNotSaveToClipboard') });
    }
  };
  modulePdfUrl() {
    const currentParams = qs.parse(new URL(location).searchParams.toString());
    const params = {
      ...currentParams,
      tx_htwstudyplan_studyplan: {
        action: 'pdfExport',
        controller: 'Studyplan',
        studyplanUid: this.props.match.params.studyplan,
        userSelection: this.props.selectedModules,
      },
      no_cache: 1,
    };
    const paramsString = qs.stringify(params);
    return new URL(`?${paramsString}`, location);
  }

  studyplanPdfUrl() {
    const currentParams = qs.parse(new URL(location).searchParams.toString());
    const params = {
      ...currentParams,
      tx_htwstudyplan_studyplan: {
        action: 'studyplanPdfExport',
        controller: 'Studyplan',
        studyplanUid: this.props.match.params.studyplan,
        userSelection: this.studyplanModules(),
      },
      no_cache: 1,
    };
    const paramsString = qs.stringify(params);
    return new URL(`?${paramsString}`, location);
  }

  studyplanModules() {
    let modulesArray = [];

    this.props.semesters.map((semester, key) => {
      modulesArray[semester.name] = modulesArray[semester.name] || [];

      semester.modules.map((module) => {
        let showModule = module;
        if (module.placeholderType === PLACEHOLDER_TYPE_CORE_ELECTIVE) {
          const selected =
            this.props.selectedModules[key + 1][`selected-${module.uid}`];
          showModule = module.coreElectiveModules.find(
            (module) => module.uid === selected
          );
        }

        modulesArray[semester.name].push(showModule.uid);
      });
    });
    return modulesArray;
  }

  render() {
    return (
      <div ref={this.ref}>
        <TwoColumns
          className="overview"
          left={
            <>
              <h2>{localize('yourStudyplan')}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.studyplan.lastPageText,
                }}
              ></div>
              <div className="mb-3">
                <a
                  href={this.modulePdfUrl()}
                  target="_blank"
                  className="btn btn-primary d-flex align-items-center justify-content-center py-1"
                  rel="noreferrer"
                >
                  {localize('modulesAsPdf')}
                </a>
                <div className="mt-3">
                  <a
                    href={this.studyplanPdfUrl()}
                    target="_blank"
                    className="btn btn-primary d-flex align-items-center justify-content-center py-1"
                    rel="noreferrer"
                  >
                    {localize('studyplanAsPdf')}
                  </a>
                </div>
                <div className="mt-3">
                  <Tooltip text={this.state.clipboard}>
                    <Link
                      to={this.deepLink()}
                      onClick={this.onCopy}
                      className="btn btn-primary d-flex align-items-center justify-content-center py-1"
                    >
                      {localize('copyLink')}
                    </Link>
                  </Tooltip>
                </div>
              </div>
            </>
          }
          right={this.semesters()}
        />
      </div>
    );
  }
}

export default withRouter(Overview);
